import React, { VoidFunctionComponent } from "react";

export const OlapicSpecificWidget: VoidFunctionComponent<{ addToUrl: string, productId: string }> = ({
    addToUrl,
    productId
}) => {
    return (
        <>
            <div id="olapic_specific_widget"></div>
            <script type="text/javascript"
                id="olapic_script"
                src={"https://photorankstatics-a.akamaihd.net/743d2e78a76dedeb07e0745158547931/static/frontend/latest/build.min.js" + addToUrl}
                data-olapic="olapic_specific_widget" data-instance="c31f80368f858e49f1398b9942275782"
                data-apikey="c07d609a8857e0e19a0ba1cb4664dd9831fc4d71cd0e4a2742cc03be104edf6c"
                data-tags={productId} data-lang="fr_FR" defer></script>
        </>
    );
}
